import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgInternet = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-internet';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M11.34 3.281A8.68 8.68 0 0 0 5.819 5.82c-1.344 1.343-2.192 3.027-2.485 4.94-.096.63-.096 1.85 0 2.48.398 2.594 1.87 4.839 4.07 6.205 1.518.943 3.456 1.42 5.206 1.282 2.156-.17 4.069-1.044 5.571-2.546s2.376-3.415 2.546-5.571c.214-2.714-.976-5.533-3.073-7.281-1.795-1.495-4.014-2.215-6.314-2.048M10.295 5.01l-.157.25a17 17 0 0 0-.851 1.66 13.3 13.3 0 0 0-.975 3.803l-.049.517H6.531c-1.622 0-1.731-.004-1.731-.07 0-.122.11-.697.2-1.05.599-2.346 2.613-4.41 4.955-5.079.322-.092.379-.097.34-.031m3.996.113c2.58.852 4.542 3.222 4.889 5.907l.028.21h-3.476l-.027-.35c-.141-1.839-.881-4.101-1.844-5.63l-.158-.254c-.043-.071.112-.04.588.117m-2.147.249c.424.579 1.013 1.686 1.333 2.508.363.931.649 2.133.708 2.977l.027.383H9.788l.027-.383c.087-1.237.546-2.789 1.205-4.077.354-.693.904-1.577.98-1.577.011 0 .076.076.144.169m-3.829 7.832c.131 1.207.442 2.415.93 3.606.213.522.732 1.547.972 1.923.219.342.219.347.016.301-.523-.117-1.413-.488-1.966-.82C6.701 17.273 5.439 15.599 5 13.88c-.09-.353-.2-.928-.2-1.05 0-.066.109-.07 1.733-.07h1.734zm5.872-.154c-.108 1.269-.589 2.838-1.264 4.13-.28.536-.7 1.244-.842 1.42l-.081.1-.081-.1c-.142-.176-.562-.884-.842-1.42-.68-1.3-1.155-2.853-1.264-4.13l-.025-.29h4.424zm4.996-.08c-.276 2.121-1.593 4.122-3.45 5.243-.547.331-1.442.704-1.966.821-.203.046-.203.041.016-.301.24-.376.759-1.401.972-1.923.37-.904.675-1.95.82-2.811.062-.372.144-1.031.145-1.169 0-.066.11-.07 1.745-.07h1.745z"
    })
  }));
});
export default SvgInternet;